import logo from './logo.svg';
import './App.css';
import Navbar from './components/navbar';
import Homepage from './components/HomePage';
import Footer from './components/footer';
import About from './components/about';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Academics from './components/academics';
import Admissions from './components/admissions';
import Events from './components/events';
import Primary from './components/primarylevel';
import StudentLife from './components/studentlife';
import Form from './components/form';
import AdmissionForm from './components/Admisssionsform';
import AcademicPrograms from './components/rankridgegrades';
import PhoneOtpPopup from './components/phoneOtpPopup';
import WhatsApp from './components/WhatsApp';
import CallButton from './components/callbuttons';
import StateBoard from './components/StateBoard';
import PrePrimary from './components/pre_primary';
import PrimarySchool from './components/Primary';
import Secondary from './components/secondary';
import CbseSchool from './components/School';
import SchoolIIT_JEE from './components/SchoolIIT-JEE';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import EnquiriesList from './components/enquirieslist';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Navbar/>
      <WhatsApp />
          <CallButton />
      <Routes>
    <Route path='/' element={ <Homepage/>}/>
    <Route path='/about-us' element={ <About/>}/>
    <Route path="/academics" element={ <AcademicPrograms status={false}/>}/>
    <Route path='/admissions' element={<Admissions/>}/>
    <Route path='/events' element={<Events />}/>
    <Route path="/primary" element={<Primary/>}/>
    <Route path='/student-life' element={<StudentLife />}/>
    <Route path='/form' element={<AdmissionForm />}/>
      <Route path='/blog' element={<BlogList />}/>
        <Route path='/blog/:slug' element={<BlogPost />}/>
        {/* <Route path='/enquiries-list' element={<EnquiriesList />}/> */}

    <Route path='/state-board-education' element={<StateBoard/>}/>
    <Route path='/pre-primary-education' element={<PrePrimary />}/>
    <Route path="/primary-school-education" element={<PrimarySchool/>}/>
    <Route path='/middle-secondary-education' element={<Secondary />}/>
    <Route path='/best-cbse-schools-in-hyderabad' element={<CbseSchool />}/>
     <Route path='/Top-iit-jee-neet-foundation' element={<SchoolIIT_JEE />}/>
     <Route path='*' element={<Homepage />}/>

    </Routes>
      
    <Footer />
   
    </BrowserRouter>

    </div>
  );
}

export default App;
